import { createModalStore } from '@/shared/lib/modal';

export const useManageBoostersModalStore = createModalStore();
